import { useState } from "react";

export function useReviewSubmitted(defaultValue) {
  const [reviewSubmitted, setReviewSubmitted ] = useState(defaultValue);
  return {
    reviewSubmitted,
    setReviewSubmitted
  };
}
